/*
  +-------------------------------------------------------------+
  !     CODE SOURCE MATERIALS                                   !
  !     OUESTADAM CONFIDENTIAL                                  !
  !                                                             !
  !     OUESTADAM CONFIDENTIAL                                  !
  !     (C) COPYRIGHT OUESTADAM 2024                            !
  !     Licensed Internal Code - Property of OUESTADAM          !
  +-------------------------------------------------------------+
  +-------------------------------------------------------------+
  !                                                             !
  !  File  : sissifConfig.js                                    !
  !  Desc. : www.ouestadam.com Translation table                !
  !                                                             !
  !  Author: D.ESTEVE                                           !
  !  Modif.: 04/12/2024                                         !
  !                                                             !
  !  0.1: Creation                                              !
  +-------------------------------------------------------------+
*/
/*=============== Definitions ==================================*/
/*
--- wwww translation table
*/
export const wwwTrans = {
    "common": {
        "cancel": {
            en: "Cancel",
            fr: "Annuler"
        }, "return": {
            en: "Return",
            fr: "Retour"
        },
        "cookies": {
            en: "This application doesn't use any Cookie",
            fr: "Cette application n'utilise aucun Cookie"
        }
    },
    "coordinate": {
        "name": {
            en: "Denis ESTEVE",
            fr: "Denis ESTEVE"
        }, "company": {
            en: "OUESTADAM-ESTEVE freelance",
            fr: "Micro-entreprise OUESTADAM-ESTEVE"
        }, "object": {
            en: "Fullstack software developer",
            fr: "Développeur de logiciels fullstack"
        }, "siret": {
            en: "SIRET: 98 52 83 860 00015",
            fr: "SIRET: 98 52 83 860 00015"
        }, "ape": {
            en: "APE: 6201-Z",
            fr: "APE: 6201-Z",
        }, "address1": {
            en: "1400 Chemin de la plus haute Sine",
            fr: "1400 Chemin de la plus haute Sine"
        }, "address2": {
            en: "06140 Vence - France",
            fr: "06140 Vence - France"
        }, "email": {
            en: "denis@ouestadam.com",
            fr: "denis@ouestadam.com"
        }, "labelFreeware": {
            en: "Freewares developed by D.ESTEVE:",
            fr: "Freewares développés par D.ESTEVE :"
        }, "labelCV": {
            en: "D.ESTEVE's Web page:",
            fr: "Page Web de D.ESTEVE :"
        }
    },
    "skillDev": {
        "title": {
            en: "Software development",
            fr: "Développement de logiciels"
        },
        "line1": {
            en: "- Web applications (front-end) development with React, Mui, Carbon, HTML/CSS...",
            fr: "- Développement d'applications Web (front-end) sous React, Mui, Carbon, HTML/CSS..."
        },
        "line2": {
            en: "- Back-end server development with NodeJs, Java, REST Api...",
            fr: "- Développement de la partie serveur (back-end) sous NodeJs, Java, Api REST..."
        },
        "line3": {
            en: "- Standalone applications development with ElectronJs/Forge...",
            fr: "- Développement d'applications locales avec ElectronJs/Forge..."
        },
        "line4": {
            en: "- Languages: Javascript, Typescript, Java, C, C++, Perl...",
            fr: "- Programmation en langages : Javascript, Typescript, Java, C, C++, Perl..."
        }
    },
    "skillVirtual": {
        "title": {
            en: "Virtual environments",
            fr: "Environnements virtuels"
        },
        "line1": {
            en: "- Docker images outputs.",
            fr: "- Production d'images Docker."
        },
        "line2": {
            en: "- VMWare Virtual machines bring-up.",
            fr: "- Mise en place de machines virtuelles sur VMWare."
        },
        "line3": {
            en: "- Virtual machines on cloud bring-up (OVH Cloud,...).",
            fr: "- Mise en place de machines virtuelles sur Cloud (OVH Cloud,...)."
        },
        "line4": {
            en: "",
            fr: ""
        }
    },
    "skillInfra": {
        "title": {
            en: "Infrastructures",
            fr: "Infrastructures"
        },
        "line1": {
            en: "- NAS, SAN, Local Network configuration.",
            fr: "- Configuration de NAS, de SAN, et de réseaux locaux."
        },
        "line2": {
            en: "- Operating System installation and maintenance: Linux, Windows, Aix, MacOs.",
            fr: "- Installation et maintenance des OS Linux, Windows, Aix, MacOS."
        },
        "line3": {
            en: "",
            fr: ""
        },
        "line4": {
            en: "",
            fr: ""
        }
    },
    "skillBuild": {
        "title": {
            en: "Build environment",
            fr: "Environnement de production de logiciels"
        },
        "line1": {
            en: "- Software production environment bring-up.",
            fr: "- Mise en place d'environnements de production de logiciels."
        },
        "line2": {
            en: "- Production tools: Git, GitHub, Apache SVN, Jenkins, Artifactory, Nexus...",
            fr: "- Outils de production: Git, GitHub, Apache SVN, Jenkins, Artifactory, Nexus..."
        },
        "line3": {
            en: "",
            fr: ""
        },
        "line4": {
            en: "",
            fr: ""
        }
    },
    "skillFreeware": {
        "title": {
            en: "Development by D.ESTEVE examples",
            fr: "Exemples de développements réalisés par D.ESTEVE"
        },
        "line1": {
            en: "- Freewares developed with React.js and Electron Forge: ",
            fr: "- Freewares développés avec React.js et Electron Forge : "
        },
        "line2": {
            en: "- Example of Web site developed with React.js: ",
            fr: "- Exemple de site Web développé avec React.js : "
        },
        "line3": {
            en: "",
            fr: ""
        },
        "line4": {
            en: "",
            fr: ""
        }
    },
    "freeware": {
        "noMobile": {
            en: "Not any Freeware available for mobiles.",
            fr: "Aucun Freeware de disponible pour les mobiles"
        },
        "download": {
            en: "Download",
            fr: "Télécharger"
        },
        "gitHub": {
            en: "GitHub repository",
            fr: "URL GitHub"
        },
        "app1Title": {
            en: "oetaskreport: Tasks Reporting tool",
            fr: "oetaskreport :  Outil de rapport d'activités"
        },
        "app1Line1": {
            en: "This freeware application allows to report activities per client and per task.",
            fr: "Cette application freeware permet de faire des rapports d'activités par client et par tâche."
        },
        "app1Line2": {
            en: "It's a standalone software which doesn't require any additional product and any Internet connection.",
            fr: "C'est un logiciel autonome qui ne requiert ni de produit additionnel ni de connexion internet."
        },
        "app1Line3": {
            en: "Version for Windows 10/11 64bits: ",
            fr: "Version pour Windows 10/11 64bits : "
        },
        "app1Line4": {
            en: "Version for Linux Debian/Ubuntu 64bits: ",
            fr: "Version pour Linux Debian/Ubuntu 64bits : "
        },
        "app1Line5": {
            en: "Version for Linux RedHat/CentOs 64bits: ",
            fr: "Version pour Linux RedHat/CentOS 64bits : "
        },
        "app1Line6": {
            en: "Documentation and source code are available on GitHub: ",
            fr: "La documentation et le code source sont disponibles sur GitHub : "
        },
        "linksTitle": {
            en: "Recommended artists Web sites",
            fr: "Sites Web d'artistes recommandés"
        },
        "linksLine1": {
            en: "If you are interested by arts, we recommend the following Web sites:",
            fr: "Si vous êtes intéressé par les arts, nous vous recommandons les sites Web suivants:"
        },
        "linksLine2": {
            en: "Figurative paintings: ",
            fr: "Peintures figuratives : "
        },
        "linksLine3": {
            en: "Contemporary arts: ",
            fr: "Arts contemporains : "
        }
    }
};